import type * as React from 'react';
import { useMemo } from 'react';
import { FormSectionContext } from './FormSectionContext.tsx';

export interface IFormSectionProps {
  enabled?: boolean;
  removeHelpMargin?: boolean;
  children?: React.ReactNode;
}

export function FormSection(props: IFormSectionProps) {
  const { enabled, removeHelpMargin, children } = props;

  const context = useMemo(
    () => ({ enabled, removeHelpMargin }),
    [enabled, removeHelpMargin],
  );

  return (
    <FormSectionContext.Provider value={context}>
      {children}
    </FormSectionContext.Provider>
  );
}
